import { ca } from '@cian/analytics';
import { offerHelper } from '../../presenter';
import { IOffer } from '../../types/offer';

export type TCardKPLabel = 'card_name_in_newlist' | 'card_photo_in_newlist' | 'card_name_kp_in_newlist';

export const trackGoToCardKP = (offer: IOffer, label: TCardKPLabel, position: number) => {
  const product = offerHelper(offer).getAnalyticsInfo();

  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'goto_CardKP',
    label,
    products: [{
      ...product,
      offerType: 'offer',
      position,
      variant: product.variant ? product.variant.split('/') : undefined,
    }],
  });
};

export const trackSuburbanMultiOfferClick = (id: number, label: string, position: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'to_multioffer_listing',
    label,
    products: [{
      id,
      offerType: 'KP',
      position,
    }],
  });
};
